// firebase-init.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID
};

let app = null;
let analytics = null;
let appCheck = null;

function firebaseInit() {
  if (!app) {
    app = initializeApp(firebaseConfig);
    try {
      // App Check debug token per lo sviluppo in locale: abilita le callable senza reCAPTCHA.
      // Attivo solo su localhost: in produzione l'hostname è diverso e il token non viene mai impostato.
      if (
        process.env.FIREBASE_APPCHECK_DEBUG_TOKEN &&
        (location.hostname === 'localhost' || location.hostname === '127.0.0.1')
      ) {
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.FIREBASE_APPCHECK_DEBUG_TOKEN;
      }
      appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(process.env.RECAPTCHA_V3_KEY),
        isTokenAutoRefreshEnabled: true
      });
    } catch (error) {
      console.warn('App Check non disponibile', error);
    }
  }
  return { app, appCheck };
}

// Export the function to initialize Firebase
export { firebaseInit };

// Make it available globally
window.firebaseInit = firebaseInit;
